export interface IModulePageI18n {
	readonly title: string;
	readonly locale: string;
	readonly text: string;
	readonly link: string;
}

export class ModulePageI18n implements IModulePageI18n {
	private _title: string;
	private _locale: string;
	private _text: string;
	private _link: string;

	constructor(title: string, locale: string, text: string, link: string) {
		this._title = title;
		this._locale = locale;
		this._text = text;
		this._link = link;
	}

	public get title(): string {
		return this._title;
	}

	public get locale(): string {
		return this._locale;
	}

	public get text(): string {
		return this._text;
	}

	public get link(): string {
		return this._link;
	}
}
